import { FC } from 'react'
import { sensorStore } from '../../store/sensor'
import { Skeleton } from 'antd'
import { useTranslation } from 'react-i18next'

interface BGCProps {
	color: string
	text: string
	isSide?: boolean
	textColor?: string
}

export const SensorBGC: FC<BGCProps> = ({
	color,
	text,
	isSide,
	textColor
}) => {
	const { t } = useTranslation()
	const { isFetched: isSensorsFetched } = sensorStore()

	if (!isSensorsFetched)
		return (
			<Skeleton.Input
				block
				active
				style={{ minWidth: 'auto', width: '100%' }}
			/>
		)

	return (
		<div
			style={{
				backgroundColor:
					isSide && color === 'gray'
						? '#8091B1'
						: `var(--${color})`,
				color: textColor
					? textColor
					: !isSide && color === 'gray'
						? '#000'
						: '#fff',
				borderRadius: '4px',
				textAlign: 'center',
				padding: '5.5px',
				width: '100%',
				boxSizing: 'border-box',
				fontSize: isSide ? 13.45 : 16,
				fontWeight: isSide ? 500 : 400
			}}>
			{t(text)}
		</div>
	)
}
